import { useEffect, useState } from "react"
import { DataTypePaging, SuccessFetch } from "types"
import { useApi } from "utils"
import { ListType } from "../../types"


type FilterState = {
    page?: number
    approved?: string
    limit?: number
    start_date?: string
    end_date?: string
    location_id?: string
    source?: string
}

export function useList({ page, approved, start_date, end_date, location_id, source, limit }: FilterState) {

    const defaultValue = {
        payload: [],
        pagination_data: {
            page: 0,
            pages: 0,
            size: 0,
            total: 0
        }
    }

    const api = useApi();
    const [data, setData] = useState<DataTypePaging<ListType>>(defaultValue);
    const [isLoading, setLoading] = useState(true)

    const params: { [key: string]: number | string | undefined } = {}
    if (page) params.page = page;
    if (approved) params.approved = approved;
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;
    if (location_id) params.location_id = location_id;
    if (source) params.source = source;
    if (limit) params.limit = limit;

    const fetchUrl = () => {
        return api.get("/invadjustment/data_inv_adjustment?",{params})
    }

    const fetchData = () => {
        setLoading(true);

        fetchUrl().then((res: SuccessFetch<DataTypePaging<ListType>>) => {
            setData(res.data);
        }).catch(() => {
            setData(defaultValue);
        }).finally(() => {
            setLoading(false);
        });
    }

    const refetch = () => fetchData();

    useEffect(() => {
        fetchData();

        return () => {
            setData(defaultValue);
            setLoading(true);
        }
        // eslint-disable-next-line
    }, [page, approved, start_date, end_date, location_id, source , limit]);

    return { data, isLoading, refetch }
}